import { createI18n } from "vue-i18n";
import datetimeFormats from "./datetimes";
import messages from "./messages";

export default createI18n({
  locale: localStorage.getItem('locale'),
  fallbackLocale: 'en',
  legacy: false,
  globalInjection: true,
  datetimeFormats,
  messages
})